import wx from 'weixin-js-sdk'			//微信sdk依赖
import axios from '@/assets/api/axios';       // 引用全局


function getJSSDK (url, dataForWeixin) {
  // 调用后台接口换取参数U

  axios.post("/zsdyckserver/share/getWeichatShareParas?shareUrl=" + url, {})
    .then(res => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.resultData.appId, // 必填，公众号的唯一标识
        timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.resultData.nonceStr, // 必填，生成签名的随机串
        signature: res.resultData.signature, // 必填，签名
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
      });

      wx.checkJsApi({
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          window.console.log("接口通过")
        }
      });

      wx.ready(function () {
        //2.1 监听“分享给朋友”及“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.updateAppMessageShareData({
          title: dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          success: function success (res) {
            console.log('已分享');
          },
        });

        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        wx.updateTimelineShareData({
          title: dataForWeixin.title,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          success: function success (res) {
            //alert('已分享');
          },
        });

      })
      wx.error(function (res) {
        console.log(JSON.stringify(res) + "微信验证失败");
      });
    }
    )
}

export default {
  // 获取JSSDK
  getJSSDK: getJSSDK,
}
